<template>
  <div id="loginPage">
    <main>
      <article>
        <form class="login" @submit.prevent="login" :class="{disabled: wait}">
          <h2 class="login-title">Sign In</h2>

          <!-- Username -->
          <div class="input-group">
            <input type="text" class="form-control" v-model="username" placeholder="Username" autocomplete="on" autofocus>
          </div>

          <!-- Password -->
          <div class="input-group">
            <input type="password" class="form-control" v-model="password" placeholder="Password" autocomplete="on">
          </div>

          <!-- Submit Button -->
          <div class="input-group">
            <button class="btn-submit" :disabled="wait">
              <span v-if="wait">
                <i class="fa fa-spinner fa-pulse"></i>
              </span>
              Sign In
            </button>
          </div>

          <!-- Error Message -->
          <div v-if="error" class="error-msg">
            {{ error }}
          </div>
        </form>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      error: '',
      wait: false,
      roles: [],
    }
  },
  mounted() {
    
    
  },
  methods: {
    async checkToken() {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const res = await fetch("http://localhost:5000/api/protected", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        if (res.ok) {
          // Токен валиден — редирект на Home
          this.$router.push("/home");
        } else {
          // Токен невалиден — удаляем его
          localStorage.removeItem('token');
          localStorage.removeItem("username");
        }
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem("username");
      }
    },
    async check_role() {
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      const params = new URLSearchParams({ user: username });

      const res = await fetch(`/api/role?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await res.json();
      this.roles = data.roles;
      return this.roles;
    },

    async login() {
      this.error = "";
      if (!this.username || !this.password) {
        this.error = "Please enter username and password";
        return;
      }

      this.wait = true;

      try {
        const res = await fetch("https://dnqreport.noc.solutions/api/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: this.username,
            password: this.password
          })
        });

        const data = await res.json();

        if (!res.ok) {
          this.error = data.error || "Login failed";
        } else {
          
          localStorage.setItem("token", data.token);
          localStorage.setItem("username", this.username);
          localStorage.setItem("refresh_token", data.refresh_token);

          const roles = await this.check_role();
          if (roles.includes('admin')) {
            this.$router.push('/')
          } else if (roles.includes('manager')) {
            this.$router.push('/calls')
          } else if (roles.includes('customer')) {
            this.$router.push('/calls')
          } else if (roles.includes('cross_sales_configurator')) {
            this.$router.push('/Calls_quota')
          } else if (roles.includes('QA')) {
            this.$router.push('/refund_requests')
          }

        }
      } catch (err) {
        this.error = "Server error, try again later";
      } finally {
        this.wait = false;
      }
    }
  }
}
</script>


<style>
/* Страница */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#loginPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}

/* main растягиваем на весь контейнер */
#loginPage main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* Форма */
#loginPage article {
  background: #ffffff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  width: 640px;
}

#loginPage article,
#loginPage article * {
  box-sizing: border-box;
}


/* Заголовок формы */
.login-title {
  text-align: center;
  color: #4e54c8;
  margin-bottom: 25px;
  font-weight: 600;
}

.input-group {
  margin-bottom: 18px;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #6a11cb;
  box-shadow: 0 0 10px rgba(106, 17, 203, 0.3);
}

.btn-submit {
  width: 100%;
  padding: 12px 0;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease, transform 0.2s ease;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px; /* расстояние между иконкой и текстом */
}

.btn-submit:hover {
  background: linear-gradient(135deg, #5a0fc1, #1e63d6);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
}

.btn-submit:active {
  transform: translateY(1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Ошибка */
.error-msg {
  color: #ff4d4f;
  text-align: center;
  font-size: 14px;
}

/* Состояние disabled */
.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
